import React, { useEffect } from "react";

// Tiny intersection-observer hook for reveal animations.
export function useReveal() {
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    if (!("IntersectionObserver" in window)) {
      els.forEach((el) => el.classList.add("is-visible"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}

// Reusable eyebrow label.
export const Eyebrow = ({ children, color, className = "" }) => (
  <div
    className={`eyebrow inline-flex items-center gap-3 ${className}`}
    style={color ? { color } : undefined}
  >
    <span className="block w-8 h-px bg-current" />
    {children}
  </div>
);

// Reusable section wrapper.
export const Section = ({ id, children, className = "", testId }) => (
  <section
    id={id}
    data-testid={testId || `section-${id}`}
    className={`relative py-20 sm:py-28 lg:py-32 ${className}`}
  >
    <div className="max-w-7xl mx-auto px-6 sm:px-10">{children}</div>
  </section>
);
